var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _vm.siteSelectShow
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "專區",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "siteId"
                              }
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  attrs: { allowClear: "" },
                                  on: { change: _vm.siteChange },
                                  model: {
                                    value: _vm.model.siteId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "siteId", $$v)
                                    },
                                    expression: "model.siteId"
                                  }
                                },
                                _vm._l(_vm.siteList, function(item, index) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: index,
                                      attrs: {
                                        value: item.id,
                                        label: item.text
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(item.siteName) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "内容編碼",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "contentCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "自動生成", disabled: "" },
                            model: {
                              value: _vm.model.contentCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "contentCode", $$v)
                              },
                              expression: "model.contentCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "内容名称",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "contentName"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入内容名称" },
                            model: {
                              value: _vm.model.contentName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "contentName", $$v)
                              },
                              expression: "model.contentName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "内容圖片",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "contentImg"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            staticClass: "avatar-uploader",
                            attrs: {
                              text: "上傳",
                              "upload-source": "hhemp",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.contentImg,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "contentImg", $$v)
                              },
                              expression: "model.contentImg"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "内容描述",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "contentDesc"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入内容描述" },
                            model: {
                              value: _vm.model.contentDesc,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "contentDesc", $$v)
                              },
                              expression: "model.contentDesc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "状态",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "status"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              dictCode: "empzone_content_status",
                              "allow-clear": ""
                            },
                            model: {
                              value: _vm.model.status,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "status", $$v)
                              },
                              expression: "model.status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "內容類型",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "contentType"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              dictCode: "empzone_content_contentType",
                              "allow-clear": ""
                            },
                            model: {
                              value: _vm.model.contentType,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "contentType", $$v)
                              },
                              expression: "model.contentType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.model.contentType == "Attachment"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "附件",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "fileUrl"
                              }
                            },
                            [
                              _c("j-upload", {
                                attrs: {
                                  newWindowOpen: "true",
                                  "upload-source": "hhemp",
                                  bizPath: "null",
                                  multiple: false,
                                  disabled: _vm.formDisabled
                                },
                                model: {
                                  value: _vm.model.fileUrl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "fileUrl", $$v)
                                  },
                                  expression: "model.fileUrl"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.model.contentType == "service" ||
                  _vm.model.contentType == "course"
                    ? _c(
                        "div",
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "内容链接",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "contentUrl"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入内容链接" },
                                    model: {
                                      value: _vm.model.contentUrl,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "contentUrl", $$v)
                                      },
                                      expression: "model.contentUrl"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "内容管理单位",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "contentManage"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入内容管理单位"
                                    },
                                    model: {
                                      value: _vm.model.contentManage,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "contentManage",
                                          $$v
                                        )
                                      },
                                      expression: "model.contentManage"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.model.contentType == "unit"
                    ? _c(
                        "div",
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "單位名稱",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "unitName"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入單位名稱" },
                                    model: {
                                      value: _vm.model.unitName,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "unitName", $$v)
                                      },
                                      expression: "model.unitName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "單位介紹",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "unitIntroduction"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入單位介紹" },
                                    model: {
                                      value: _vm.model.unitIntroduction,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "unitIntroduction",
                                          $$v
                                        )
                                      },
                                      expression: "model.unitIntroduction"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "聯繫人",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "unitContact"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入聯繫人" },
                                    model: {
                                      value: _vm.model.unitContact,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "unitContact", $$v)
                                      },
                                      expression: "model.unitContact"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "聯繫方式",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol
                                  }
                                },
                                [
                                  _c("a-input", {
                                    staticStyle: { width: "30%" },
                                    attrs: { placeholder: "请输入座機" },
                                    model: {
                                      value: _vm.model.unitTelephone,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "unitTelephone",
                                          $$v
                                        )
                                      },
                                      expression: "model.unitTelephone"
                                    }
                                  }),
                                  _c("a-input", {
                                    staticStyle: { width: "30%", left: "5%" },
                                    attrs: { placeholder: "请输入手機" },
                                    model: {
                                      value: _vm.model.unitPhone,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "unitPhone", $$v)
                                      },
                                      expression: "model.unitPhone"
                                    }
                                  }),
                                  _c("a-input", {
                                    staticStyle: { width: "30%", left: "10%" },
                                    attrs: { placeholder: "请输入郵箱" },
                                    model: {
                                      value: _vm.model.unitMail,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "unitMail", $$v)
                                      },
                                      expression: "model.unitMail"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "排序",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "sortNo"
                          }
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入排序" },
                            model: {
                              value: _vm.model.sortNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sortNo", $$v)
                              },
                              expression: "model.sortNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }